require('@material/dialog/mdc-dialog.scss');
require('@material/form-field/mdc-form-field.scss');
require('@material/checkbox/mdc-checkbox.scss');

require('@os/mdc/dialog.scss');
require('@os/mdc/text-field.scss');
require('@os/mdc/checkbox.scss');
require('@os/mdc/floating-label.scss');

define(['jquery', '@material/dialog', '@material/textfield', '@material/checkbox', '@material/radio', '@os/form-data'], function($, mdcDialog, mdcTextField, mdcCheckbox, mdcRadio, formData) {

	var templateRecommendCompany = require('../../view/recommend-company.hbs');

	return {
		init: function() {
			$(document).on('click', '[data-action="recommend-company"]', function(event) {
				event.preventDefault();
				event.stopPropagation();

				if ($('#dialog_recommend_company').length > 0) {
					$('#dialog_recommend_company').remove();
				}
				$("body").append(templateRecommendCompany());
				
				$('#dialog_recommend_company #recommendForm').find('.mdc-text-field').each(function(index, value) {
					mdcTextField.MDCTextField.attachTo($(this)[0]);
				});
				
				$('#dialog_recommend_company #recommendForm').find('.mdc-checkbox').each(function(index, value) {
					checkbox = mdcCheckbox.MDCCheckbox.attachTo($(this)[0]);
				});

				$('#dialog_recommend_company #recommendForm').find('.mdc-radio').each(function(index, value) {
					radio = mdcRadio.MDCRadio.attachTo($(this)[0]);
				});
					
				dialog = new mdcDialog.MDCDialog(document.querySelector('#dialog_recommend_company'));
				dialog.show();
			});

			$(document).on('click', 'button[data-action="recommend-company-next-step"]', function(event) {
				event.preventDefault();
				event.stopPropagation();

				switch ($(this).data("step")) {
					case 1:
						$.ajax({
							url: '/api/survey/request',
							type: 'POST',
							data: formData($('#recommendForm input[name="company_name"]')),
							dataType: 'json',
							context: this
						}).done(function(data) {
							$(this).hide();
							$(this).parents(".mdc-dialog").addClass("mdc-dialog-alert");
							if (data.success) {
								tabIndex = 1;
							} else {
								tabIndex = 2;
							}
							$("#recommendForm .panels .panel").removeClass("os-dialog__panel--active");
							$("#recommendForm .panels .panel:eq(" + tabIndex + ")").addClass("os-dialog__panel--active");
						});
						break;
				}
			});
		}
	};
});